import { render, staticRenderFns } from "./PWAInstallNotification.vue?vue&type=template&id=1c7ac763&scoped=true&"
import script from "./PWAInstallNotification.vue?vue&type=script&lang=js&"
export * from "./PWAInstallNotification.vue?vue&type=script&lang=js&"
import style0 from "./PWAInstallNotification.vue?vue&type=style&index=0&id=1c7ac763&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7ac763",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VIcon,VSnackbar})
